import getPhoneType from './getPhoneType';

const isAndroid = (): boolean => {
  return getPhoneType() === 'android';
};

export default isAndroid;
